/**
 * Sinal de "logado, mas sem assinatura ativa" (spec 10, R4).
 *
 * O backend ganhou um gate atras da flag `SUBSCRIPTION_GATE_ENABLED`: rotas de
 * conteudo de `/api/v1` passam a responder **402 Payment Required** com
 * `{ code: 'subscription_required' }` quando `User#has_active_subscription?` e
 * falso. A allowlist (autenticacao, perfil, planos, pagamento, onboarding)
 * continua em 200.
 *
 * Por que 402 e nao 401: 401 significa "nao logado" e o caminho natural dele e
 * limpar a sessao e mandar para /login. Quem esta sem plano CONTINUA logado — e
 * precisa continuar logado, senao nao consegue comprar. Este modulo guarda esse
 * estado.
 *
 * Por que um modulo solto e nao o authStore: `authStore.ts` importa `lib/api.ts`.
 * Se `api.ts` importasse o store de volta teriamos ciclo — o mesmo motivo pelo
 * qual `tokenHolder.ts` existe. Aqui o padrao e o mesmo, com um `useSyncExternalStore`
 * por cima para as telas reagirem.
 *
 * O servidor e a UNICA autoridade sobre o bloqueio: nada aqui deduz o estado a
 * partir de `user.subscription_status`. Com a flag desligada nenhum 402 chega,
 * logo nenhuma tela muda — que e exatamente o comportamento exigido.
 */
import { useSyncExternalStore } from 'react'

/** Codigo devolvido por `SubscriptionAccess#render_subscription_required`. */
export const SUBSCRIPTION_REQUIRED_CODE = 'subscription_required'

export const SUBSCRIPTION_REQUIRED_STATUS = 402

let blocked = false
const listeners = new Set<() => void>()

function emit(): void {
  listeners.forEach((listener) => listener())
}

function setBlocked(next: boolean): void {
  if (blocked === next) return
  blocked = next
  emit()
}

/** Chamado pelo `ApiClient` ao receber o 402 do gate. */
export function markSubscriptionBlocked(): void {
  setBlocked(true)
}

/**
 * Some com o bloqueio. Usado no logout e depois de um pagamento aprovado — o
 * proximo request que passar pelo gate reintroduz o bloqueio se ele persistir.
 */
export function clearSubscriptionBlock(): void {
  setBlocked(false)
}

export function isSubscriptionBlocked(): boolean {
  return blocked
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

/** Hook de leitura para as guardas de rota. */
export function useSubscriptionBlocked(): boolean {
  return useSyncExternalStore(subscribe, isSubscriptionBlocked, isSubscriptionBlocked)
}
